import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import { FormControlLabel, Checkbox } from '@material-ui/core';
import { useAppContext } from '../context/AppContext';
import InputGrouping from './InputGrouping';
import VerticalStepperRe from './VerticalStepperRe';

const TabContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: rgb(105, 105, 105);
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
`;

const TabContentOverlay = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${props => props.theme.spacing.large};
  opacity: ${props => props.disabled ? 0.5 : 1};
  pointer-events: ${props => props.disabled ? 'none' : 'auto'};
`;

const ContentRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-top: ${props => props.theme.spacing.medium};

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    flex-direction: column;
  }
`;

const StepperColumn = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 200px;
  margin-right: ${props => props.theme.spacing.large};

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    margin-right: 0;
    margin-bottom: ${props => props.theme.spacing.medium};
  }
`;

const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-top: ${props => props.theme.spacing.medium};
`;

const StyledFormControlLabel = styled(FormControlLabel)`
  & .MuiFormControlLabel-label {
    color: ${props => props.theme.colors.text};
  }
`;

const SingleAthleteTabContent = () => {
  const {
    athlete,
    captureModeIsActive,
    editingEvalModeIsActive,
    evalInputModeActive, 
    setEvalInputModeActive
  } = useAppContext();

  const [showNorms, setShowNorms] = useState(true);
  const [showNotes, setShowNotes] = useState(false);

  const handleShowNormsChange = useCallback(() => setShowNorms(prev => !prev), []);
  const handleShowNotesChange = useCallback(() => setShowNotes(prev => !prev), []);

  const handleDataTypeInputChange = useCallback((event) => {
    setEvalInputModeActive(!event.target.checked);
  }, [setEvalInputModeActive]);

  return (
    <TabContentContainer>
      <TabContentOverlay disabled={!athlete}>
        <CheckboxContainer>
          <StyledFormControlLabel
            control={
              <Checkbox
                style={{ color: '#FDBA31'}}
                color="primary"
                onChange={handleDataTypeInputChange}
                checked={!evalInputModeActive}
                disabled={!captureModeIsActive && !editingEvalModeIsActive}
              />
            }
            label={!captureModeIsActive && !editingEvalModeIsActive ? "Collected during Training" :  "Save as Training Data"}
          />
        </CheckboxContainer>
        <ContentRow>
          <StepperColumn>
            <VerticalStepperRe />
            <CheckboxContainer>
              <StyledFormControlLabel
                control={
                  <Checkbox
                    style={{ color: '#FDBA31'}}
                    color="primary"
                    onChange={handleShowNormsChange}
                    checked={showNorms}
                  />
                }
                label="Show norms"
              />
              <StyledFormControlLabel
                control={
                  <Checkbox
                    style={{ color: '#FDBA31'}}
                    color="primary"
                    onChange={handleShowNotesChange}
                    checked={showNotes}
                  />
                }
                label="Show notes"
              />
            </CheckboxContainer>
          </StepperColumn>
          {athlete && <InputGrouping showNorms={showNorms} showNotes={showNotes} />}
        </ContentRow>
      </TabContentOverlay>
    </TabContentContainer>
  );
};

export default SingleAthleteTabContent;